import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function getDisconnectGoogle(): Promise<void> {
  const res = await fetchOrchidAPI(
    "/api/scheduler_calendar_integrations/disconnect_google",
  );
  if (!res.ok) {
    throw new Error(`failed to get: ${getErrorDetail(await res.text())}`);
  }
  return;
}
